import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
	public formLogin: FormGroup;
	public submitting = false;
	public error = false;

	public aviso_erro = "Dados incorretos";

	constructor(private auth: AuthService,
				private fb: FormBuilder,
				private router: Router) { }

	ngOnInit() {
		this.criaForm();
	}

	criaForm() {
		this.formLogin = this.fb.group({
			usuario_login: ['', Validators.required],
			password: ['', Validators.required]
		});
	}
	

	doLogin() {


		this.resetaErro();
		this.submitting = true;

		this.auth.login(this.formLogin.value).subscribe(
			(resp) => { 

				if(resp["user"]["usuario_situacao"] == false){
					this.error = true;
					this.aviso_erro = "Usuário não Localizado!";
					this.submitting = false;
				}else{
					this.auth.loggedIn("ok");
					this.router.navigate(['home']);
				}

			},
			(errorResponse: HttpErrorResponse) => { 
				console.log(errorResponse);  
				this.error = true;
				this.submitting = false;
			}
		);


		/*this.auth.login(this.formLogin.value.login, this.formLogin.value.senha).then((data: any) => {
			if (data.allowed) {
				this.auth.loggedIn(data.usuario);
				this.router.navigate(['home']);
			}
			else {
				console.log('erro');
				this.error = true;
				this.submitting = false;
			}
		}).catch(err => {
			console.log(err);
			this.submitting = false;
		});*/



	}


	resetaErro() {
		this.error = false;
	}

}
